import React from 'react';

import { ContentCard, ContentCardIconType, VerticalSpacing, VerticalSpacingType } from 'ui/component';

import classNames from './EABDMachineReasoningContentCard.module.scss';

export interface MachineReasoningContentCardProps {
  readonly isInFocus: boolean;
  readonly style?: React.CSSProperties;
}

export const MachineReasoningContentCard = React.memo<MachineReasoningContentCardProps>((props) => {
  const { isInFocus, style } = props;

  const BodyWithBottomSpacing = React.useMemo(() => {
    return (
      <React.Fragment>
        <p className={classNames.body}>
          {'Realizing the vision of intent-based telecom networks by bringing human-like common sense into AI.'}
        </p>
        <VerticalSpacing type={VerticalSpacingType.X2} />
      </React.Fragment>
    );
  }, []);

  const RenderCaptionCallback = React.useCallback((caption: string) => {
    return (
      <div className={classNames.headlineListItem}>
        <div className={classNames.circle} />
        <p className={classNames.caption}>{caption}</p>
      </div>
    );
  }, []);

  return (
    <ContentCard title={'Machine Reasoning'} iconType={ContentCardIconType.NODE} isInFocus={isInFocus} style={style}>
      {BodyWithBottomSpacing}
      <div className={classNames.headlineList}>
        {RenderCaptionCallback('Act on limited or never seen before data')}
        {RenderCaptionCallback('Enable explainability & auditability of AI predictions and recommendations')}
        {RenderCaptionCallback('Resolve conflicting recommendations')}
      </div>
    </ContentCard>
  );
});
